export enum SettingsActiveTab {
	Profile = 'profile_info',
	Billing = 'billing_info',
	Notification = 'notification_info'
}
